/* eslint-disable no-undef */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { withRouter } from 'react-router';
import { motion } from 'framer-motion';
import { Box, Grid } from '@material-ui/core';
import ImageTop from './images/img_top.svg';
import ColorButtonPurple from './ColorButtonPurple.js';
import TopFooter from './TopFooter.js';

class Top extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isMobile: false };
  }
  handleToStep1 = () => {
    if (window.innerWidth < 960) {
      this.setState({ isMobile: true });
    } else {
      // eslint-disable-next-line react/prop-types
      this.props.history.push('/step1');
    }
  };

  render() {
    let mobileMessage;
    if (this.state.isMobile) {
      mobileMessage = (
        <Box m={2}>
          <p className="error-message">ワークプレイス・シュミレーター体験版はPC端末専用です</p>
        </Box>
      );
    }
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <div>
            <h2 className="question">ワークプレイス・シュミレーター</h2>
            <h4 className="description">
              社員数や出社率などの数値を入力いただくだけで、
              <br />
              オフィスの必要面積や家賃の軽減の可能性を提示するサービスです。
            </h4>
            <Box mt={2}>
              <p className="top_discription1">
                COVID-19によりオフィス空間は、大きな変化の波に襲われています。
                <br />
                出社率の低下、リモートワークによるフリーアドレスの浸透。
                <br />
                人の少ないオフィスの光景を見て、誰もが疑問に思うはず、「実際、オフィスに必要な面積は?」と。
                <br />
                一方で、今後のオフィス要件の設定は複雑で、答えを出しづらいのも事実です。
                <br />
                ここではワークパスが独自に開発したシュミレーターを<strong className="top_marker">無料でご体験</strong>
                いただけます。
              </p>
            </Box>

            <Box height={2}>{mobileMessage}</Box>
            <p className="small_text">-For free-</p>
            <Box m={4} className="button">
              <ColorButtonPurple size="large" variant="outlined" onClick={this.handleToStep1}>
                START
              </ColorButtonPurple>
            </Box>
            <h2 className="question">
              過去、現在、今後、<span> そして</span>未来の
            </h2>

            <Grid container justify="center">
              <Grid item xs={3}>
                <Box paddingTop={3} paddingRight={1}>
                  <img src={ImageTop} />
                </Box>
              </Grid>
              <Grid item md={5} sm={6}>
                <Box className="top_discription2" pt={1}>
                  <p>
                    <strong className="top_marker">過去のオフィス</strong>、
                    <strong className="top_marker">現在のオフィス</strong>、 <br />
                    働き方を変革した<strong className="top_marker">今後のオフィス</strong>。 <br />
                    それぞれを比較することで今後の働き方を検討する <br />
                    お手伝いができれば幸いです。
                    <br />
                    また、イノベーションや協働を主目的とした
                    <br />
                    <strong className="top_marker">codetta 推奨オフィス</strong>
                    の想定規模も併せてご提案します。
                  </p>
                </Box>
              </Grid>
            </Grid>
          </div>
          <Box marginTop={8}>
            <TopFooter />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Top;
